import { Component } from "react";
import { RouteComponentProps, RouterProps, withRouter } from "react-router-dom";
import { appContext } from "../../../AppContext";
import AlertModal, { IOptions } from "../../Dialogs/AlertDialog/AlertModal";
import Header, { IProps as IHeaderProps } from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Messages, { IMessage } from "../Messages/Messages";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import React from "react";

const drawerWidth = 241;

class Layout extends Component<IProps, IState>
{
    private get appContext() { return appContext(); }
    private get alert() { return appContext().alert; }
    private get appState() { return appContext().state; }
    private mainContentRef = React.createRef<HTMLDivElement>();
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);

        this.appContext.router =
        {
            history: this.props.history,
            location: this.props.location,
            match: this.props.match,
            staticContext: this.props.staticContext,
        };

        this.state =
        {
            isPrivate: props.isPrivate,
            showAlert: false,
            alertTitle: "",
            alertMessage: "",
            messages: [],
            mobileOpen: false,
        };

    }

    public componentDidMount(): void
    {
        this.appState.autoMap(this, i => ({ messages: i.messages }));
        // todo: bug:
        // pages fire their componentDidMount before the layout so if a page tries to show an alert in componentDidMount it doesn't work
        // solution is to get rid of the changed event and have the alert get it's state from the appState
        this.alert.changed = (show, title, message, options) => this.alertChanged(show, title, message, options);
    }

    public componentWillUnmount(): void
    {
        this.alert.changed = undefined;
    }

    private alertChanged(show: boolean, title: string, message: string, options?: IOptions): Promise<void>
    {
        return new Promise((resolve, reject) =>
        {
            this.setState({
                showAlert: show,
                alertTitle: title,
                alertMessage: message,
                alertOptions: options,
            }, () => resolve());
        });
    }

    private hideAlert(): void
    {
        this.alert.hide();
    }
    private handleDrawerToggle(): void
    {
        this.setState({
            mobileOpen: !this.state.mobileOpen 
        });
    };
    public render(): JSX.Element
    {
        return (
            <>
                <AlertModal
                    show={this.state.showAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    options={this.state.alertOptions}
                    onClose={() => this.hideAlert()}
                />
                {this.state.isPrivate && 
             <Box sx={{ display: "flex" }} className="page-container">
                <CssBaseline />
                {/* Sidebar in Drawer */}
                <Box
                    component="nav"
                    sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 },zIndex: 1049 }}
                    aria-label="sidebar navigation"
                >
                    {/* Temporary drawer for mobile */}
                    <Drawer
                        variant="temporary"
                        open={this.state.mobileOpen}
                        onClose={() => this.handleDrawerToggle()}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            display: { xs: "block", sm: "none" },
                            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
                        }}
                    >
                        <Sidebar {...this.props} mainContentRef={this.mainContentRef} />
                    </Drawer>
                    {/* Permanent drawer for desktop */}
                    <Drawer
                        variant="permanent"
                        sx={{
                            display: { xs: "none", sm: "block" },
                            "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
                        }}
                        open
                    >
                           <Sidebar {...this.props} mainContentRef={this.mainContentRef}/>
                           </Drawer>
                </Box>
                {/* Main Content */}
                <Box
                    id="main-content"
                    tabIndex={0}
                    ref={this.mainContentRef}
                    component="main"
                    sx={{
                        flexGrow: 1,
                        width: { sm: `calc(100% - ${drawerWidth}px)` }, marginTop: '70px',overflow:'hidden'
                    }}
                >
                    {/* AppBar with Header */}
                <AppBar
                    position="fixed"
                    sx={{
                        width: { sm: `calc(100% - ${drawerWidth}px)` }, zIndex: 1049,
                        ml: { sm: `${drawerWidth}px` },pr:0,boxShadow:'none',bgcolor:'var(--ui-background-alternate)'
                    }}
                >
                    <Toolbar sx={{ px: 0, bgcolor: 'var(--ui-background-alternate)' }}>
                        <IconButton
                            color="secondary"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => this.handleDrawerToggle()}
                            sx={{ mx: 2, display: { sm: "none" } }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Header {...(this.props as unknown as IHeaderProps)} />
                    </Toolbar>
                </AppBar>
                    {/* <Toolbar /> */}
                    {this.state.isPrivate && (
                        <div>
                            <Messages messages={this.state.messages} />
                            {this.props.children}
                        </div>
                    )}
                
                </Box>
                </Box>
                }
                {!this.state.isPrivate && this.props.children}
            </>);
    }
}

export default withRouter(Layout);

interface IProps extends RouteComponentProps, RouterProps
{
    isPrivate: boolean;
}

interface IState
{
    isPrivate: boolean;
    showAlert: boolean;
    alertTitle: string;
    alertMessage: string;
    alertOptions?: IOptions;
    messages: IMessage[];
    mobileOpen: boolean;
}
